
import { useState,useCallback,useRef,useImperativeHandle,forwardRef } from 'react'
import CustomStore from 'devextreme/data/custom_store';
import SelectBox,{SelectBoxTypes} from 'devextreme-react/select-box';
import { t } from 'i18next';
import { productSupplyParamService } from '../services/product_supply_parameter-service';
import { clear } from 'console';

interface ProductSupplyParameterQueryProps{
    onchaged?: (vendor_code:any,location_code:any,product_code:any) => void,  
    clear?: (vendor_code:any,location_code:any,product_code:any) => void,  
}

const ProductSupplyParameterQuery = forwardRef((props:ProductSupplyParameterQueryProps, ref) => {

    useImperativeHandle(ref, () => ({

        clear() {
          sb_vendors.current?.instance.clear();         
        }
    
      }));    
    const sb_vendors= useRef<SelectBox>(null);
    const sb_locations= useRef<SelectBox>(null);
    const sb_products= useRef<SelectBox>(null);
     let vendor_code:any;
    let location_code:any;
    let product_code:any;
    

    const [suppliers_store] = useState(new CustomStore({load: productSupplyParamService.getSupplierLookups,}));
    const [location_store, set_location_store] = useState();
    const load_location_store = async () => { 
        set_location_store(await productSupplyParamService.getLocationLookups(vendor_code))
    };
    const [product_store, set_product_store] = useState();
    const load_product_store = async () => { 
        set_product_store(await productSupplyParamService.getProductLookups(vendor_code,location_code))
    };
    const onSupplierChanged =useCallback( (e: SelectBoxTypes.ValueChangedEvent) => {
        sb_locations.current?.instance.clear();        
        sb_products.current?.instance.clear();
        
        vendor_code=e.value;
        location_code=null;
        product_code=null;
        load_location_store();
        load_product_store();
        if(props.onchaged!=null) props.onchaged(vendor_code,location_code,product_code);
    }, []);
     
    const onLocationChanged = useCallback((e: SelectBoxTypes.ValueChangedEvent) => { 
        location_code=e.value; 
        product_code=null; 
        sb_products.current?.instance.clear();

        load_product_store();
        if(props.onchaged!=null) props.onchaged(vendor_code,location_code,product_code);

    }, []);
    
    const onProductChanged = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {         
        product_code=e.value; 
        load_product_store();
        if(props.onchaged!=null) props.onchaged(vendor_code,location_code,product_code);

    }, []);

    return  <div className="row mb-12">
    <label className="col-lg-1 col-form-label required fw-bold fs-6"> {t("syncflow:supplier")}</label>
    <div className="col-lg-3">
        <div className="row">
            <div className="fv-row">
                <SelectBox
                    ref={sb_vendors }
                    name="suppliersLookups"
                    dataSource={suppliers_store}
                    valueExpr="id"
                    displayExpr="name"
                    onValueChanged={onSupplierChanged}
                    showClearButton={true}>                    
                </SelectBox>
            </div>
        </div>
    </div>
    {/* <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:location")}</label>
    <div className="col-lg-3">
        <div className="row">
            <div className="fv-row">
                <SelectBox   
                    ref={sb_locations }              
                    name="locations"
                    dataSource={location_store}
                    valueExpr="id"
                    displayExpr="name"
                    searchEnabled={true}
                    onValueChanged={onLocationChanged}
                    showClearButton={true} />
            </div>
        </div>
    </div> */}
    <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lb_product")}</label>
    <div className="col-lg-3">
        <div className="row">
            <div className="fv-row">
                <SelectBox
                    ref={sb_products }
                    name="productLookups"
                    dataSource={product_store}
                    valueExpr="id"
                    displayExpr="name"
                    onValueChanged={onProductChanged}
                    showClearButton={true}
                     />
            </div>
        </div>
    </div>

</div> 
  });
  export default  ProductSupplyParameterQuery;